import React from 'react';
import SocialMedia from './socialCard';

function Media(props) {
    return (
        <div className="media_container">
            <SocialMedia name={props.name} imgsrc={props.imgsrc} website={props.website} />
        </div>
    );
}

function Footer() {
    return (
        <div className="social_handle">
            <p id="head">Let's connect</p>
            <div className="platforms">
                <Media name="LinkedIn" imgsrc={require("../img/icons8-linkedin-50.png")} website="https://www.linkedin.com/in/ninad-d-706277b6/" />
                <Media name="GitHub" imgsrc={require("../img/icons8-github-48.png")} website="https://github.com/Ninad10code/" />
                <Media name="Facebook" imgsrc={require("../img/icons8-facebook-48.png")} website="https://www.facebook.com/profile.php?id=100011791892179" />
                <Media name="Twitter" imgsrc={require("../img/icons8-twitter-48.png")} website="https://twitter.com/ninad_dadmal" />
                <Media name="Mail" imgsrc={require("../img/icons8-important-mail-48.png")} website="mailto:ninad.dadmal10@gmail.com" />
            </div>


        </div>
    );
}

export default Footer;